import { useDeleteBilling } from "./api/deleteBilling";
import { Button } from "reactstrap";


const DeleteBilling = ({handleCloseModal, billingId, dataLineID}: DeleteBillingProps)  => {
  
  const deleteBillingMutation = useDeleteBilling({ billingId, dataLineID});
  const handleSubmit = async (): Promise<void> => {
    deleteBillingMutation.mutateAsync({ 
      billingId: billingId,
      dataLineID: dataLineID
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε τoν Έλεγχο;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteBillingProps{
  billingId: number;
  dataLineID: number;
  handleCloseModal: () => void;
}

export default DeleteBilling;